<template>
    
    <form @submit="submit" class="item-editor-form"> 
        <label>{{ $t('route_view.stop')}} : {{stopName}}</label><br>
        <template v-for="(item, index ) in this.systemLangs">
            <label v-bind:key="'labelkey'+index" v-bind:for="'ta'+index">{{ $t(item) }}</label><br v-bind:key="'br'+index" />
            <label v-bind:key="'nameLabel'+index">{{ $t('destination.name') }}</label>
            <b-form-input v-bind:key="'namekey'+index"
                v-model="itemList.get(index).nimi"
                v-bind:id="'nameid'+item.kielikoodi">
            </b-form-input>
            <label v-bind:key="'shortTextLabel'+index">{{ $t('destination.shortText') }}</label>
            <b-form-input v-bind:key="'shortTextkey'+index"
                v-model="itemList.get(index).shortText"
                v-bind:id="'shortText'+index">
            </b-form-input> 
            <label v-bind:key="'viaLabel'+index">{{ $t('destination.via') }}</label>
            <b-form-input v-bind:key="'viakey'+index"
                v-model="itemList.get(index).kautta"
                v-bind:id="'viaid'+index">
            </b-form-input>
            <label v-bind:key="'driverLabel'+index">{{ $t('destination.driverText') }}</label>
            <b-form-input v-bind:key="'drivertextkey'+index"
                v-model="itemList.get(index).driverText"
                v-bind:id="'driverText'+index">
            </b-form-input>
                          
          </template>
        <FormButtons :reset="false" :remove="false" @submit="submit"></FormButtons>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>    
    
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import { mapGetters } from 'vuex'

export default {
    components: {
        FormButtons
    },
    props: {
        items: {
            required: true,
        },
        action: { default: "new" },
        stopName: { default: "" },
        route: { default: "" },
    },
    data() {
        return {
            //systemLangs: [],
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },
    created: function(){
        this.$store.dispatch('getSystemParameters')
    },
    computed: {
        delModalTitle() {
            return this.$t("destination.delete.title")
        },
        validDestinations() {            
            let editedDestinationList = [];

            for( let de of this.items ) {
                if( de.nimi ) 
                    editedDestinationList.push(de);
            }
            return editedDestinationList;
        },  
        itemList() {
            if( this.items == undefined )
                return new Map()
            return this.items
        },
         ...mapGetters( { 
            systemLangs: 'systemLanguages'
        })
    },    
    watch: {
        item(){
            this.ok = this.error = this.loading = false;            
        } 
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();   
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            let destinations = Array.from( this.itemList.values() )
            this.$store.dispatch('timetable/updateDestination' , destinations, this.route).then(response => {
                this.ok = response.data.errorCode == 0;
                this.error = !this.ok;
            })
            .catch( () => { 
                this.error = true; 
            }) 
            .finally(() => {
                this.$store.dispatch('timetable/getRouteDestinations' , this.route )
                this.loading = false;
            })
            
        },
        reset(event){
            event.preventDefault();
            this.item = {};              
        }
    }
}
</script>

